BookingFactory.$inject = ['_', 'API', 'Club', 'Court', 'Time', 'BookingService'];

/* @ngInject */
function BookingFactory(_, API, Club, Court, Time, BookingService) {
    var Booking = BookingService.Booking,
        BookingFixed = BookingService.BookingFixed;

    var service = {
        create: create,
        collect: {
            simple: simple,
            courts: collectByCourts,
            days: collectByDays
        }
    };

    ////////////////

    function create(payload) {
        if (payload.fixed || payload.bookeable_type === 'App\\BookingFixed') {
            return new BookingFixed(payload);
        }
        return new Booking(payload);
    }

    /**
     * Collects a simple array into an array of Bookings
     * @method simple
     * @param  {array} payload Array of objects
     * @return {array} Array of Bookings
     */
    function simple(payload) {
        return _.map(payload, function (data) {
            // Court may no longer be in the cache (e.g. deleted court),
            // fall back to the court embedded in the API payload.
            var court =
                Court.get(data.court_id) ||
                (data.court ? Court.create(data.court) : undefined);
            return create(data).setCourt(court);
        });
    }


    function collectByCourts(courts) {
        return _.map(courts.plain(), function (payload) {
            var court = Court.create(payload);
            court.title = court.name;

            normaizeOneDay(court, payload.booking_once, payload.booking_fixed, payload.booking_done || []);
            return court;
        });
    }

    /**
     *
     * @method collect.courts
     * @param  {Object} courtData
     * @param  {Array} range
     * @return {Obect}
     */
    function collectByDays(courtData, range) {
        var court = Court.create(courtData);
        return normalizeOneCourt(court, range, courtData.booking_once, courtData.booking_fixed, courtData.booking_done || []);
    }

    // Private Methods

    /**
     * Given a court with booking_once and booking_fixed, it normalices them into FE format
     * @method events.normaizeOneDay
     * @param  {Court} court
     * @param  {array} booking_once
     * @param  {array} booking_fixed
     * @param  {array} booking_done
     */
    function normaizeOneDay(court, booking_once, booking_fixed, booking_done) {
        var once = normalizeArrayOfOnce(booking_once, court),
            done = normalizeArrayOfOnce(booking_done, court),
            fixed = normalizeArrayOfFixed(booking_fixed, court);

        court.events = once.concat(fixed, done);
    }

    /**
     * Given a court with a day (moment), it normalizes into an array of FE formatted bookings,
     * the bookings corresponding to that day
     * @method normaizeDays
     * @param  {Court} court
     * @param  {Moment} day
     * @param  {array} booking_once
     * @param  {array} booking_fixed
     * @param  {array} booking_done
     * @return {Array of Bookings}
     */
    function normaizeDays(court, day, booking_once, booking_fixed, booking_done) {
        var once = [],
            done = [],
            once_day = day.format('Y-MM-DD'),
            fixed = [],
            fixed_day = day.format('d');

        if (booking_once[once_day]) {
            once = normalizeArrayOfOnce(booking_once[once_day], court);
        }
        if (booking_fixed[fixed_day]) {
            fixed = normalizeArrayOfFixed(booking_fixed[fixed_day], court);
        }
        if (booking_done[once_day]) {
            once = normalizeArrayOfOnce(booking_done[once_day], court);
        }


        return once.concat(fixed, done);
    }

    /**
     * Normalize one court given a range.
     *  Applies the normalizeDays on every date of the range.
     * @method normalizeOneCourt
     * @param  {Court} court
     * @param  {Object: start-end} range
     * @param  {array} booking_once
     * @param  {array} booking_fixed
     * @param  {array} booking_done
     * @return {Object: row for schedule}
     */
    function normalizeOneCourt(court, range, booking_once, booking_fixed, booking_done) {
        return _.map(Time.rangeToArray(range), function (time) {
            return {
                title: time.format('dddd DD [de] MMMM'),
                id: time,
                divisible: court.divisible,
                events: normaizeDays(court, time, booking_once, booking_fixed, booking_done)
            };
        });
    }

    /**
     * Normalizes the bookings_once into an FE formatted array
     * @method normalizeArrayOfOnce
     * @param  {Array of BE Bookings} arr
     * @return {Array of FE Bookings}
     */
    function normalizeArrayOfOnce(arr, court) {
        return _.map(arr, function (data) {
            return (new Booking(data)).setCourt(court);
        });
    }

    /**
     * Normalizes the bookings_fixed into an FE formatted array
     * @method normalizeArrayOfFixed
     * @param  {Array of BE Bookings} arr
     * @return {Array of FE Bookings}
     */
    function normalizeArrayOfFixed(arr, court) {
        return _.map(arr, function (booking) {
            return (new BookingFixed(booking)).setCourt(court);
        });
    }

    return service;

}

export default BookingFactory;